import { Versions } from "@app/constants/versions.ts";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Box, Typography } from "@mui/material";
import { Link } from "@tanstack/react-router";
import { IconButton } from "bi-lib";

export default function Footer() {
    return (
        <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            borderTop={"1px solid #e0e0e0"}
            py={1}
            gap={1}
        >
            <Typography>
                &copy; 2024 - Schumaker & Company - Time and Expense Information Reporting System (TEIRS)
            </Typography>
            <Link to={"/change-log"}>
                <IconButton tooltip={`Version ${Versions[0].toString()}`}>
                    <HelpOutlineIcon />
                </IconButton>
            </Link>
        </Box>
    );
}
